/*
 * Contains logic responsible for controlling the pagination feature.
 */

window.addEventListener("DOMContentLoaded", function() {
    init();
}, false);


function init() {
    var paginateBy,
        pageInput,
        firstPage,
        nextPage,
        prevPage,
        lastPage;

    paginateBy = document.querySelector("form.paginate-by select[name='paginate-by-choice']");
    if (paginateBy) {
        // initialize pagination value (required to get correct value on back)
        var currSearchParams = new URLSearchParams(window.location.search);
        var currPaginateBy = currSearchParams.get("paginate_by");
        if (currPaginateBy) {
            paginateBy.value = currPaginateBy;
        } else {
            paginateBy.value = 25;
        }

        paginateBy.addEventListener("change", function(e) {
            var newPaginateBy = paginateBy.options[paginateBy.selectedIndex].text;
            var url = new URL(window.location.href);
            var searchParams = new URLSearchParams(url.search);
            searchParams.set("paginate_by", newPaginateBy);
            searchParams.set("page", "1");
            url.search = searchParams;
            window.location.href = url.href;
        }, false);
    }

    pageInput = document.querySelector("span.page-display input[name='page']");
    if (pageInput) {
        // navigate to a new page number in the table
        pageInput.addEventListener("input", function(e) {
            var newPage = pageInput.value;
            if (newPage !== '') {
                newPage = parseInt(newPage, 10);
                if (newPage >= pageInput.min && newPage <= pageInput.max) {
                    var url = new URL(window.location.href);
                    var searchParams = new URLSearchParams(url.search);
                    searchParams.set("page", newPage);
                    url.search = searchParams;
                    window.location.href = url.href;
                }
            }
        }, false);
    }
    // TODO: there's a lot of repeated code here, maybe refactor later

    firstPage = document.querySelector("button.first-page");
    if (firstPage) {
        firstPage.addEventListener("click", function(e) {
            var url = new URL(window.location.href);
            var searchParams = new URLSearchParams(url.search);
            searchParams.set("page", "1");
            url.search = searchParams;
            window.location.href = url.href;
        }, false);
    }

    prevPage = document.querySelector("button.prev-page");
    if(prevPage) {
        prevPage.addEventListener("click", function(e) {
            var url = new URL(window.location.href);
            var searchParams = new URLSearchParams(url.search);
            var currPage = searchParams.get("page");
            if (currPage) {
                currPage = parseInt(currPage, 10);
                searchParams.set("page", String(currPage - 1));
                url.search = searchParams;
                window.location.href = url.href;
            }
        }, false);
    }

    nextPage = document.querySelector("button.next-page");
    if (nextPage) {
        nextPage.addEventListener("click", function(e) {
            var url = new URL(window.location.href);
            var searchParams = new URLSearchParams(url.search);
            console.log(searchParams);
            var currPage = searchParams.get("page");
            if (currPage) {
                currPage = parseInt(currPage, 10);
            } else {
                currPage = 1;
            }
            searchParams.set("page", String(currPage + 1));
            url.search = searchParams;
            window.location.href = url.href;
        }, false);
    }

    lastPage = document.querySelector("button.last-page");
    if (lastPage) {
        lastPage.addEventListener("click", function(e) {
            var url = new URL(window.location.href);
            var searchParams = new URLSearchParams(url.search);
            if (pageInput){
                searchParams.set("page", String(pageInput.max));
                url.search = searchParams;
                window.location.href = url.href;
            }
        }, false);
    }
}